import { MoveSheetContent } from '@/modules/move/entities';
import { MOVE_SHEET_COLUMN } from '@/modules/move/entities/constants/moveSheetColumn';
import { getFormattedDateEUA } from '@/utils/format';

export const transformRowToForm = (row: MoveSheetContent | null): MoveSheetContent | null => {
  if (!row) {
    return null;
  }

  const getFormattedDateByColumnKey = (key?: MOVE_SHEET_COLUMN) => {
    if (!key || !row[key]) {
      return;
    }

    return getFormattedDateEUA(String(row[key]));
  };

  return {
    ...row,
    [MOVE_SHEET_COLUMN.dataNascimento]: getFormattedDateByColumnKey(
      MOVE_SHEET_COLUMN.dataNascimento,
    ),
    [MOVE_SHEET_COLUMN.dataAngariacao]: getFormattedDateByColumnKey(
      MOVE_SHEET_COLUMN.dataAngariacao,
    ),
    [MOVE_SHEET_COLUMN.dataCasamento]: getFormattedDateByColumnKey(MOVE_SHEET_COLUMN.dataCasamento),
    [MOVE_SHEET_COLUMN.dataInicioVigencia]: getFormattedDateByColumnKey(
      MOVE_SHEET_COLUMN.dataInicioVigencia,
    ),
    [MOVE_SHEET_COLUMN.dataAdmissao]: getFormattedDateByColumnKey(MOVE_SHEET_COLUMN.dataAdmissao),
  };
};
